import * as React from "react";
import { SVGProps, memo } from "react";

const BxBxCheck = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 15.586L6.707 12.293L5.293 13.707L10 18.414L19.707 8.707L18.293 7.293L10 15.586Z" fill="currentColor" /></svg>;

const Memo = memo(BxBxCheck);
export default Memo;